import { fetchAPI } from './common'

export interface OrgMetaDTO {
  _priv: Record<string, boolean>
}

export const fetchOrgMeta = (orgSlug: string): Promise<OrgMetaDTO> =>
  fetchAPI(`v1/org/${orgSlug}/meta`).then((response) => response.json())
